import Main from './Main.vue'

const routes = [{ name: 'documents/main', component: Main, path: '/documents' }]

export { routes }
